import { Box, Text } from 'grommet';
import { Alert, StatusWarning } from 'grommet-icons';

/**
 * The warning shown from 80% of an account's storage limit (the owner is also emailed at 80% and 100%).
 * At 100%, uploads are refused until there's room.
 */
export const StorageWarning = ({ percentageUsed }: { percentageUsed: number | null }) => {
  if (percentageUsed === null || percentageUsed < 80) return null;
  const full = percentageUsed >= 100;
  return (
    <Box
      direction="row"
      gap="small"
      align="center"
      pad="small"
      round="xsmall"
      background={full ? 'status-critical' : 'status-warning'}
    >
      {full ? <Alert color="white" /> : <StatusWarning color="white" />}
      <Text size="small" color="white">
        {full
          ? 'Your storage is full, so new uploads are paused. Add a storage pack or delete files you no longer need.'
          : `Your storage is ${Math.floor(percentageUsed)}% full. When it's full, new uploads will pause: add a storage pack or delete files you no longer need.`}
      </Text>
    </Box>
  );
};
